import React from "react";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { useQuery } from "@tanstack/react-query";
import { getTopper } from "../Service/Api";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ISCTopperHome = () => {
  // ✅ Fetch toppers using React Query v5 syntax
  const { data: topperData } = useQuery({
    queryKey: ["topperData"],
    queryFn: getTopper,
  });

  // ✅ Fallback data if API returns empty
  const emptyArray = [
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
    {
      name: "Student Name",
      stream: "Subject",
      division: "100%",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png",
    },
  ];

  // ✅ React Slick settings (unchanged layout)
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  // ✅ Filter class X toppers (fallback to emptyArray if none)
  const toppers =
    topperData && topperData.filter((item) => item.class === "XII").length > 0
      ? topperData.filter((item) => item.class === "XII")
      : emptyArray;

  return (
    <>
      <Slider {...settings}>
        {toppers
          .sort((a, b) => {
            const divA =
              parseFloat(a.division.toString().replace("%", "")) || 0;
            const divB =
              parseFloat(b.division.toString().replace("%", "")) || 0;
            return divB - divA;
          })

          .map((item, index) => (
            <div className="item" key={index}>
              <div className="topperdiv">
                <div className="toppertaj">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }
                  >
                    <img
                      src={
                        item.attachments && Array.isArray(item.attachments)
                          ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                          : item.attachments?.includes("/Images")
                            ? item.attachments
                            : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/trophy.png"
                      }
                      alt={item.name || "Topper"}
                      className="img-fluid"
                    />
                  </LazyLoad>
                </div>

                <div className="topperdesc">
                  <p className="name">{item.name}</p>
                  <p className="per">{item.division}</p>
                  <p>{item.stream}</p>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </>
  );
};

export default ISCTopperHome;
